"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Main", {
  enumerable: true,
  get: function get() {
    return _Main["default"];
  }
});
Object.defineProperty(exports, "NormalFilter", {
  enumerable: true,
  get: function get() {
    return _Main.NormalFilter;
  }
});
Object.defineProperty(exports, "AdvancedFilter", {
  enumerable: true,
  get: function get() {
    return _Main.AdvancedFilter;
  }
});
Object.defineProperty(exports, "Footer", {
  enumerable: true,
  get: function get() {
    return _Main.Footer;
  }
});
Object.defineProperty(exports, "ActionItem", {
  enumerable: true,
  get: function get() {
    return _ActionItem["default"];
  }
});
Object.defineProperty(exports, "TextAction", {
  enumerable: true,
  get: function get() {
    return _ActionItem.TextAction;
  }
});
Object.defineProperty(exports, "InputAction", {
  enumerable: true,
  get: function get() {
    return _ActionItem.InputAction;
  }
});
Object.defineProperty(exports, "SelectAction", {
  enumerable: true,
  get: function get() {
    return _ActionItem.SelectAction;
  }
});
Object.defineProperty(exports, "Action", {
  enumerable: true,
  get: function get() {
    return _Action["default"];
  }
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function get() {
    return _Container["default"];
  }
});
Object.defineProperty(exports, "Criteria", {
  enumerable: true,
  get: function get() {
    return _Criteria["default"];
  }
});
Object.defineProperty(exports, "OnBackButton", {
  enumerable: true,
  get: function get() {
    return _OnBackButton["default"];
  }
});
Object.defineProperty(exports, "ThreadListPreview", {
  enumerable: true,
  get: function get() {
    return _ThreadListPreview["default"];
  }
});
exports["default"] = exports.steps = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var Yup = _interopRequireWildcard(require("yup"));

var _reactAlbus = require("react-albus");

var _formik = require("formik");

var _Main = _interopRequireWildcard(require("./Main"));

var _ActionItem = _interopRequireWildcard(require("./ActionItem"));

var _Action = _interopRequireDefault(require("./Action"));

var _Container = _interopRequireDefault(require("./Container"));

var _Criteria = _interopRequireDefault(require("./Criteria"));

var _OnBackButton = _interopRequireDefault(require("./OnBackButton"));

var _ThreadListPreview = _interopRequireDefault(require("./ThreadListPreview"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var steps = {
  main: 'MAIN',
  criteria: 'CRITERIA',
  action: 'ACTION',
  preview: 'PREVIEW'
};
exports.steps = steps;
var initialValues = {
  criteria: {
    from: []
  },
  action: []
};

var _default = function _default(_ref) {
  var _ref$values = _ref.values,
      values = _ref$values === void 0 ? initialValues : _ref$values,
      onSubmit = _ref.onSubmit,
      main = _ref.main,
      criteria = _ref.criteria,
      action = _ref.action,
      preview = _ref.preview,
      validationSchema = _ref.validationSchema;
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: values,
    validationSchema: Yup.object(validationSchema),
    onSubmit: onSubmit,
    render: function render(formikProps) {
      return /*#__PURE__*/_react["default"].createElement(_formik.FieldArray, {
        name: "action",
        render: function render(arrayHelpers) {
          return /*#__PURE__*/_react["default"].createElement(_reactAlbus.Wizard, {
            render: function render() {
              return /*#__PURE__*/_react["default"].createElement(_reactAlbus.Steps, null, /*#__PURE__*/_react["default"].createElement(_reactAlbus.Step, {
                id: steps.main,
                render: function render(props) {
                  return main(_objectSpread(_objectSpread({}, props), {}, {
                    formikProps: formikProps,
                    arrayHelpers: arrayHelpers
                  }));
                }
              }), /*#__PURE__*/_react["default"].createElement(_reactAlbus.Step, {
                id: steps.criteria,
                render: function render(props) {
                  return criteria(_objectSpread(_objectSpread({}, props), {}, {
                    formikProps: formikProps,
                    arrayHelpers: arrayHelpers
                  }));
                }
              }), /*#__PURE__*/_react["default"].createElement(_reactAlbus.Step, {
                id: steps.action,
                render: function render(props) {
                  return action(_objectSpread(_objectSpread({}, props), {}, {
                    formikProps: formikProps,
                    arrayHelpers: arrayHelpers
                  }));
                }
              }), /*#__PURE__*/_react["default"].createElement(_reactAlbus.Step, {
                id: steps.preview,
                render: function render(props) {
                  return preview(_objectSpread(_objectSpread({}, props), {}, {
                    formikProps: formikProps,
                    arrayHelpers: arrayHelpers
                  }));
                }
              }));
            }
          });
        }
      });
    }
  });
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map